<template>
	<div id="Activeuser">
		<section class="breadcrumb_area typography_breacrumb">
            <img class="breadcrumb_shap" src="img/breadcrumb/banner_bg.png" alt="">
            <div class="container">
                <div class="breadcrumb_content text-center">
                    <h1 class="f_p f_700 f_size_50 w_color l_height50 mb_20 geo_font"><span>{{ Lang('Account activation') }}</span> <span v-if="!Activated">...</span></h1>

					<div id="preloader" v-if="!Activated">
					    <div id="" class="ctn-preloader" style="position: relative;">
					        <div class="animation-preloader">
					            <div class="spinner" style="width: 100px;height: 100px;"></div>
					        </div>
					    </div>
					</div>

					<div v-if="Activated">
                    	<p class="f_400 w_color f_size_16 l_height26">{{ Lang('The account has been successfully activated') }}</p>
						<a href="/" class="app_btn geo_font">{{ Lang('Home') }}</a>
					</div>
                </div>
            </div>
        </section>
	</div>
</template>
<script type="text/javascript">
import Vue 		from 'vue';
import Com 		from '@/libs/Com.js';
import Langs	from '@/mixins/Lang.js';
// Loas sweet alert
import VueSweetalert2 from 'vue-sweetalert2';
Vue.use(VueSweetalert2);

export default {
	name 	: 'Activecompany',
    mixins 	:[ Langs ],
	data 	: function () {
		return {
			ActivationTocken 	: '',
			Activated 			: false
		}
	},

	mounted : function () {
		Vue.set(this, 'ActivationTocken', this.$route.params.action);
	},

	watch : {
		'ActivationTocken' : function () {
			this.ActivateCompanyProcess();
		}		
	},

	methods : {
		ActivateCompanyProcess : async function () {
			this.Activated = false;
			let Response = await Com.Service(254, {Token : this.ActivationTocken, Type : 2});
			if (Response.StatusCode == 1) {
				this.Activated = true;
			} else {
				this.$swal({
					title	: this.Lang('The account could not be activated'),
					text 	: this.Lang('The account could not be activated please reload the page'),
					icon 	: 'error',
					timer 	: 3000,
				})
				this.Activated = false;
			}
		}
	}
}
</script>
<style type="text/css">
header { display: none;}
</style>


// WEBPACK FOOTER //
// src/components/Activeuser/index.vue